var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading-wrapper',{attrs:{"isLoading":_vm.gridLoading}},[_c('grid-gcr',{attrs:{"data":_vm.gridData,"columns":_vm.gridColumns}}),_c('paging-gcr',{attrs:{"callback":_vm.changePage,"pageCount":_vm.pageCount}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }